import { MdDialogRef } from '@angular/material';
import { Component } from '@angular/core';

@Component({
  selector: 'app-custom-confirm-dialog',
  template: `
        <p>{{ title }}</p>
        <p>{{ message }}</p>
        <a md-button md-raised-button href="{{ url }}" target="_blank" (click)="dialogRef.close(true)" color="primary">{{ text }}</a>
        <button type="button" md-button
            (click)="dialogRef.close()">Cancel</button>
  `,
})
export class CustomConfirmDialogComponent {

  public title: string;
  public message: string;
  public url: string;
  public text: string;

  constructor(public dialogRef: MdDialogRef<CustomConfirmDialogComponent>) {

  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/component/dialog/app-custom-confirm-dialog.component.ts